import { SymbolData } from '@/modules'

export class ReelsUtil {
    public static convertBonusGrid(slotGrid: any[][]): any[][] {
        const result: any[][] = []

        for (let i = 0; i < slotGrid.length; i++) {
            result.push([])

            for (let j = 0; j < slotGrid[i].length; j++) {
                let extraData = slotGrid[i][j]

                result[i].push([0, extraData])
            }
        }

        return result
    }

    public static parseIndexes(slotGrid: SymbolData[][]): number[][] {
        const result: number[][] = []

        for (let i = 0; i < slotGrid.length; i++) {
            result.push([])

            for (let j = 0; j < slotGrid[i].length; j++) {
                result[i].push(slotGrid[i][j].id)
            }
        }

        return result
    }
}
